import { render, staticRenderFns } from "./favorites.vue?vue&type=template&id=ab92dcde&"
import script from "./favorites.vue?vue&type=script&lang=js&"
export * from "./favorites.vue?vue&type=script&lang=js&"
import style0 from "./favorites.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports